import React from "react";
import DashboardHeader from "./DashboardHeader";

const DashboardLayout = ({
  isMobile,
  isSidebarOpen,
  setIsSidebarOpen,
  currentView,
  children,
}) => {
  return (
    <div className="min-h-screen bg-orange-50">
      {/* Mobile Sidebar Overlay */}
      {isMobile && isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-10"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <main
        className={`
          transition-all duration-200 
          ${isSidebarOpen && !isMobile ? "ml-64" : "ml-0"}
          min-h-screen
        `}
      >
        <DashboardHeader
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          currentView={currentView}
        />

        {/* Content Area */}
        <div className="p-6">{children}</div>
      </main>
    </div>
  );
};

export default DashboardLayout;
